import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import { computed } from 'mobx';
import type { SupplierResponse } from 'tm3-core/api.dtos';

class SuppliersStore extends CacheStore<SupplierResponse> {
  constructor() {
    super('suppliers');
  }
  @computed
  get Current() {
    return this.All.filter((x) => x.current);
  }
}
export default SuppliersStore;
